export {}

const DEFAULT_LOCALE = "pt-BR"

const getResolvedTimeZone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone

const formatDate = (date: Date, locale = DEFAULT_LOCALE, options?: Intl.DateTimeFormatOptions): string => {
  return new Intl.DateTimeFormat(locale, options).format(date)
}

declare global {
  interface Date {
    toInputDate(): string
    toSqlDateTime(): string
    toLocaleDateTimeOrDash(locale?: string, timeZone?: string): string
    toMonthStart(): Date
    toHourLabel(locale?: string): string
    toDayMonthLabel(locale?: string): string
  }

  interface String {
    toLocaleDateTime(locale?: string, timeZone?: string): string
    toHourLabel(locale?: string): string
    toDayMonthLabel(locale?: string): string
  }
}

Date.prototype.toInputDate = function (): string {
  const offsetDate = new Date(this.getTime() - this.getTimezoneOffset() * 60000)

  return offsetDate.toISOString().slice(0, 10)
}

Date.prototype.toSqlDateTime = function (): string {
  const offsetDate = new Date(this.getTime() - this.getTimezoneOffset() * 60000)

  return offsetDate.toISOString().slice(0, 19).replace("T", " ")
}

Date.prototype.toLocaleDateTimeOrDash = function (locale = DEFAULT_LOCALE, timeZone = getResolvedTimeZone()): string {
  if (isNaN(this.getTime())) {
    return "-"
  }

  return this.toLocaleString(locale, { timeZone })
}

Date.prototype.toMonthStart = function (): Date {
  return new Date(this.getFullYear(), this.getMonth(), 1)
}

Date.prototype.toHourLabel = function (locale = DEFAULT_LOCALE): string {
  if (isNaN(this.getTime())) {
    return "-"
  }

  return formatDate(this, locale, { hour: "2-digit", hour12: false })
}

Date.prototype.toDayMonthLabel = function (locale = DEFAULT_LOCALE): string {
  if (isNaN(this.getTime())) {
    return "-"
  }

  return formatDate(this, locale, { day: "2-digit", month: "2-digit" })
}

String.prototype.toLocaleDateTime = function (locale = DEFAULT_LOCALE, timeZone = getResolvedTimeZone()): string {
  const date = new Date(this.toString())

  if (isNaN(date.getTime())) {
    return "-"
  }

  return date.toLocaleString(locale, { timeZone })
}

String.prototype.toHourLabel = function (locale = DEFAULT_LOCALE): string {
  const date = new Date(this.toString())

  return date.toHourLabel(locale)
}

String.prototype.toDayMonthLabel = function (locale = DEFAULT_LOCALE): string {
  const date = new Date(this.toString())

  return date.toDayMonthLabel(locale)
}
